// 会員情報変更 (/pages/profile). Chờ ink:api:ready → prefill GET /profile,
// submit PUT /profile, zip lookup, pref dropdown, LINE ID連携. Fail-open.

(function () {
  'use strict';

  function boot() {
    const root = document.querySelector('[data-ink-profile]');
    if (!root) return;
    const form = root.querySelector('[data-profile-form]');
    const msg = root.querySelector('[data-profile-msg]');
    const savedBanner = root.querySelector('[data-profile-saved]');
    const prefSel = form.querySelector('select[name=cc_pref_cd]');

    const setVal = (name, v) => { const el = form.elements[name]; if (el) el.value = v == null ? '' : v; };

    async function loadPrefs() {
      try {
        const j = await window.inkApi.get('/prefectures');
        const items = (j && j.data) || [];
        prefSel.innerHTML = '<option value="">選択</option>' + items.map((p) => `<option value="${p.pref_cd}">${p.pref_name}</option>`).join('');
      } catch (e) { console.warn('prefs fail', e); }
    }

    const skel = root.querySelector('[data-profile-skeleton]');
    const showGuest = () => { skel?.remove(); root.querySelector('[data-profile-guest]')?.classList.remove('hidden'); };

    // ===== LINE ID連携 (port account.line_alignment.php + account.billing.tpl.php:75-104) =====
    // Quay về từ màn hình đồng ý của LINE: callback redirect kèm ?line=ok|ng.
    // Hiện toast rồi xoá param để reload/bookmark không lặp lại thông báo.
    (function showLineResult() {
      const params = new URLSearchParams(window.location.search);
      const result = params.get('line');
      if (result !== 'ok' && result !== 'ng') return;
      window.inkToast?.(
        result === 'ok' ? 'LINE ID連携が完了しました。' : 'LINE ID連携ができませんでした。お手数ですが最初からやり直してください。',
        result === 'ok' ? 'success' : 'error',
      );
      params.delete('line');
      const qs = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    })();

    let lineLinked = false;
    async function initLineLink() {
      const block = root.querySelector('[data-line-link-block]');
      if (!block) return;
      // Backend chưa cấu hình LINE → 503 LINE_NOT_CONFIGURED (LineController::linkUrl)
      // → giữ khối ẩn thay vì đưa nút bấm vào lỗi.
      let j;
      try { j = await window.inkApi.get('/line/link-url'); } catch (e) { console.warn('line link-url fail', e); return; }
      if (!j || !j.data || !j.data.url) return;

      if (lineLinked) {
        block.querySelector('[data-line-link-desc]').textContent = 'LINE ID連携がお済みです。登録しているIDを変更する場合は下記ボタンから行えます。';
        block.querySelector('[data-line-link-btn]').textContent = '連携しているLINE IDを変更する';
      }
      block.classList.remove('hidden');

      block.querySelector('[data-line-link-btn]')?.addEventListener('click', async () => {
        // Lấy URL MỚI lúc bấm: state trong URL có hạn (services.line.state_ttl),
        // URL lấy lúc load trang có thể đã hết hạn.
        window.inkProcessing?.show();
        let r;
        try { r = await window.inkApi.get('/line/link-url'); } catch (e) { r = null; }
        const url = r && r.data && r.data.url;
        if (!url) {
          window.inkProcessing?.hide();
          window.inkToast?.((r && r.error && r.error.message) || 'ただいまLINE連携をご利用いただけません。', 'error');
          return;
        }
        // Chuyển trang → giữ overlay tới khi rời trang (rule §Processing overlay)
        window.location.href = url;
      });
    }

    async function prefill() {
      let j;
      try { j = await window.inkApi.get('/profile'); } catch (e) { showGuest(); return; }
      const d = j && j.data;
      if (!d) { showGuest(); return; }
      // bỏ skeleton + hiện form (rule §Loading)
      skel?.remove();
      form.classList.remove('hidden');
      ['user_email', 'last_name', 'first_name', 'phone_1', 'fax', 'cc_zip1', 'cc_zip2', 'cc_city', 'cc_town', 'cc_building', 'company', 'cc_brew'].forEach((k) => setVal(k, d[k]));
      setVal('email_confirm', d.user_email);
      prefSel.value = d.cc_pref_cd || '';
      form.elements.cc_mmaga.checked = Number(d.cc_mmaga) === 1;
      lineLinked = !!d.line_linked;
      if (d.line_linked) {
        root.querySelector('[data-line-row]')?.classList.remove('hidden');
        form.elements.campaign_flg.checked = Number(d.campaign_flg) === 1;
      }
    }

    // 郵便番号: 全角数字 → 半角 + bỏ ký tự không phải số (Joomla zip2Addr.js:7-8), để khách
    // không gặp lỗi 「半角数字」 khó hiểu. Chờ IME chốt chữ mới đổi (đổi giữa chừng phá IME);
    // dán 「185-0003」 vào ô đầu thì tách sang ô sau.
    const toHalfDigits = (v) => String(v || '').replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0)).replace(/[^0-9]/g, '');
    const bindZipInput = (first, second) => {
      const clean = (el) => {
        const v = toHalfDigits(el.value).slice(0, el.maxLength > 0 ? el.maxLength : 7);
        if (v === el.value) return false;
        el.value = v;
        return true;
      };
      [first, second].forEach((el) => {
        el.addEventListener('input', (e) => { if (!e.isComposing) clean(el); });
        ['compositionend', 'blur'].forEach((type) => el.addEventListener(type, () => {
          if (clean(el)) el.dispatchEvent(new Event('input', { bubbles: true }));
        }));
      });
      first.addEventListener('paste', (e) => {
        const v = toHalfDigits(e.clipboardData?.getData('text'));
        if (v.length !== 7) return;
        e.preventDefault();
        first.value = v.slice(0, 3);
        second.value = v.slice(3);
        second.dispatchEvent(new Event('input', { bubbles: true }));
      });
    };
    bindZipInput(form.elements.cc_zip1, form.elements.cc_zip2);

    // zip → 住所 auto-fill (tự chạy khi đủ 7 số, không cần bấm nút)
    const zipMsg = root.querySelector('[data-zip-msg]');
    const showZipMsg = (t) => { if (zipMsg) { zipMsg.textContent = t; zipMsg.classList.toggle('hidden', !t); } };
    let zipDone = '';
    async function lookupZip() {
      const z = ((form.elements.cc_zip1.value || '') + (form.elements.cc_zip2.value || '')).replace(/[^0-9]/g, '');
      if (z.length !== 7 || z === zipDone) return;
      zipDone = z;
      showZipMsg('');
      try {
        const j = await window.inkApi.get(`/zip/${z}`);
        const d = j && j.data;
        if (d) { if (d.pref_cd) prefSel.value = String(d.pref_cd); setVal('cc_city', d.city); setVal('cc_town', d.town); }
        else if (j && j.error) { zipDone = ''; console.warn('zip lookup error', j.error); } // network → im lặng, fail-open
        else { zipDone = ''; showZipMsg('郵便番号が見つかりません。'); } // 404 = không có mã bưu điện này
      } catch (e) { zipDone = ''; console.warn('zip lookup fail', e); /* fail-open, không chặn nhập tay */ }
    }
    form.elements.cc_zip1.addEventListener('input', lookupZip);
    form.elements.cc_zip2.addEventListener('input', lookupZip);
    root.querySelector('[data-zip-lookup]')?.addEventListener('click', () => { zipDone = ''; lookupZip(); });

    // Autokana: お名前(last_name) → tự sinh フリガナ(first_name) khi gõ IME.
    window.inkBindAutokana?.(form.elements.last_name, form.elements.first_name);

    // ===== Confirm flow (giống address) =====
    const editview = root.querySelector('[data-profile-editview]');
    const confirmPanel = root.querySelector('[data-profile-confirm]');
    const confirmBody = root.querySelector('[data-profile-confirm-body]');
    const confirmMsg = root.querySelector('[data-profile-confirm-msg]');
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    function collectPayload() {
      const payload = {};
      ['user_email', 'email_confirm', 'last_name', 'first_name', 'cc_zip1', 'cc_zip2', 'cc_pref_cd', 'cc_city', 'cc_town', 'cc_building', 'phone_1', 'fax', 'company', 'cc_brew'].forEach((k) => { payload[k] = form.elements[k] ? form.elements[k].value.trim() : ''; });
      payload.cc_pref_cd = parseInt(payload.cc_pref_cd, 10) || '';
      payload.cc_mmaga = form.elements.cc_mmaga.checked ? 1 : 0;
      if (form.elements.campaign_flg) payload.campaign_flg = form.elements.campaign_flg.checked ? 1 : 0;
      return payload;
    }

    // Confirm <dl> — 住所 gộp 都道府県+区市町村+丁目/番地+建物 như address confirm.
    function buildConfirm(payload) {
      const prefName = payload.cc_pref_cd && prefSel.selectedOptions[0] ? prefSel.selectedOptions[0].textContent : '';
      const addr = `${prefName}${payload.cc_city || ''}${payload.cc_town || ''} ${payload.cc_building || ''}`.trim();
      const lineRow = root.querySelector('[data-line-row]');
      const lineShown = form.elements.campaign_flg && lineRow && !lineRow.classList.contains('hidden');
      const rows = [
        ['メールアドレス', esc(payload.user_email)],
        ['メルマガ配信', payload.cc_mmaga === 1 ? '希望する' : '希望しない'],
        ['お名前', esc(payload.last_name)],
        ['フリガナ', esc(payload.first_name)],
        ['郵便番号', `${esc(payload.cc_zip1)}-${esc(payload.cc_zip2)}`],
        ['住所', esc(addr)],
        ['電話番号', esc(payload.phone_1)],
        payload.fax ? ['FAX番号', esc(payload.fax)] : null,
        payload.company ? ['会社名', esc(payload.company)] : null,
        payload.cc_brew ? ['部署名', esc(payload.cc_brew)] : null,
        lineShown ? ['LINE', payload.campaign_flg === 1 ? '受け取る' : '受け取らない'] : null,
      ].filter(Boolean);
      const html = rows.map(([label, value], i) => {
        // border-ink-grayLine LUÔN có để border-r dòng cuối không thành đen currentColor (vạch đậm).
        const b = i === rows.length - 1 ? '' : 'border-b ';
        return `<dt class="border-ink-grayLine ${b}bg-gray-50 px-4 py-3 font-bold sm:border-r">${label}</dt><dd class="border-ink-grayLine ${b}px-4 py-3">${value}</dd>`;
      }).join('');
      confirmBody.innerHTML = `<dl class="grid overflow-hidden rounded border border-ink-grayLine text-sm sm:grid-cols-[180px_1fr]">${html}</dl>`;
    }

    // Submit form = validate → mở CONFIRM (KHÔNG PUT ngay). Design: 入力漏れ không qua confirm.
    let pendingPayload = null;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const payload = collectPayload();
      // フリガナ + 電話番号 KHÔNG còn bắt buộc (chốt CS 2026-09-17) — hồ sơ điền tự
      // động từ 配送先 của đơn vốn thiếu 2 field này (checkout không thu kana; số
      // trùng tài khoản khác thì để trống), giữ lại đây là khách không lưu nổi hồ sơ
      // của chính mình. Server cũng đã đổi sang `nullable` (ProfileUpdateRequest).
      const missing = [['user_email', 'メールアドレス'], ['last_name', 'お名前'], ['cc_zip1', '郵便番号'], ['cc_zip2', '郵便番号'], ['cc_pref_cd', '都道府県'], ['cc_city', '区市町村'], ['cc_town', '丁目/番地']]
        .filter(([k]) => !String(payload[k] || '').trim()).map(([, l]) => l);
      if (missing.length) { msg.textContent = `必須項目をご入力ください：${[...new Set(missing)].join(' / ')}`; msg.className = 'mt-3 text-sm text-ink-red'; return; }
      if (payload.user_email !== payload.email_confirm) { msg.textContent = '確認用メールアドレスが一致しません。'; msg.className = 'mt-3 text-sm text-ink-red'; return; }
      msg.textContent = '';
      pendingPayload = payload;
      buildConfirm(payload);
      savedBanner?.classList.add('hidden');
      editview.classList.add('hidden');
      confirmPanel.classList.remove('hidden');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    root.querySelector('[data-profile-confirm-back]')?.addEventListener('click', () => {
      confirmPanel.classList.add('hidden');
      if (confirmMsg) confirmMsg.textContent = '';
      editview.classList.remove('hidden');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // この内容で変更する → PUT /profile thật.
    root.querySelector('[data-profile-confirm-submit]')?.addEventListener('click', async () => {
      if (!pendingPayload) return;
      confirmMsg.textContent = '';
      window.inkProcessing?.show();
      let j;
      try { j = await window.inkApi.put('/profile', pendingPayload); } finally { window.inkProcessing?.hide(); }
      if (j && j.data && j.data.updated) {
        confirmMsg.textContent = '変更を保存しました。'; confirmMsg.className = 'mt-3 text-center text-sm font-bold text-[#01b245]';
        setTimeout(() => {
          confirmPanel.classList.add('hidden');
          editview.classList.remove('hidden');
          msg.textContent = '変更を保存しました。'; msg.className = 'mt-3 text-sm font-bold text-[#01b245]';
          savedBanner?.classList.remove('hidden');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 900);
      } else {
        const errs = j && j.errors ? Object.values(j.errors).flat() : null;
        confirmMsg.textContent = errs ? errs.join(' / ') : ((j && j.message) || '保存に失敗しました。');
        confirmMsg.className = 'mt-3 text-center text-sm text-ink-red';
      }
    });

    // ⚠️ Phải populate options TRƯỚC khi prefill set value (nếu không pref dropdown
    // không select đúng lúc reload).
    (async () => { await loadPrefs(); await prefill(); await initLineLink(); })();
  }

  let booted = false;
  function startOnce() { if (booted) return; booted = true; boot(); }
  if (window.inkApi) startOnce();
  else { document.addEventListener('ink:api:ready', startOnce, { once: true }); window.addEventListener('load', () => setTimeout(() => { if (!window.inkApi) startOnce(); }, 1000)); }
})();
